module.exports = __webpack_public_path__ + "img/20.9ac6e6d0.jpg";